<template>
  <div class="contenedor-editar-datos-socio">
    <div class="contenedor-titulo">
      <h1>Cargar Resultado Examen</h1>
      <div class="barra"></div>
    </div>
    <router-link to="/mesa-examen-noviembre-2025" class="boton_volver_login"><span>&#8592;</span> Atrás</router-link>
    <section>
      <div class="contenedor-editar-datos-socio-izquierda">
        <img src="@/assets/patanjali.jpg" alt="Patanjali">
      </div>
      <div class="contenedor-editar-datos-socio-derecha">
        <div class="postulante_examen_img">
          <img v-if="participante.persona.imagen_perfil != null" :src="imagenRuta" :alt="`${participante.persona.nombre} ${participante.persona.apellido}`">
          <img v-else src="@/assets/image-not-available.jpg" :alt="`${participante.persona.nombre}`">
          <h2>{{ participante.persona.nombre }} {{ participante.persona.apellido }}</h2>
        </div>
        <form
          action="#"
          method="post"
          @submit.prevent="cargarExamen(examen)"
          class="form_cargar_examen"
        >
          <div class="form_section_editar_socio ancho_form">
            <label for="fecha_examen">Fecha</label>
              <input
                type="date"
                name="fecha_examen"
                id="fecha_examen"
                v-model="examen.fecha_examen"
                :disabled="cargando"
              >
              <div
              class="form_cargar_examen_mensaje_error"
                v-if="errores.fecha_examen !== null"
              >
                {{ errores.fecha_examen[0] }}
              </div>
          </div>
          <div class="form_section_editar_socio ancho_form">
            <label for="perfil_id">Certificación</label>
            <select
              id="certificacion_id"
              name="certificacion_id"
              class="form minimal"
              v-model.number="examen.certificacion_id"
              :disabled="cargando"
            >
              <option
                v-for="certificacion in certificaciones"
                :value="certificacion.certificacion_id"
                :key="certificacion.certificacion_id"
              >
                {{ certificacion.nombre }}
              </option>
            </select>
            <div
            class="form_cargar_examen_mensaje_error"
              v-if="errores.certificacion_id !== null"
            >
              {{ errores.certificacion_id[0] }}
            </div>
          </div>
          <div class="form_section_editar_socio ancho_form">
            <label for="perfil_id">Calificación</label>
            <select
              id="aprobo_id"
              name="aprobo_id"
              class="form minimal"
              v-model.number="examen.aprobo_id"
              :disabled="cargando"
            >
              <option
                v-for="resultado in resultados"
                :value="resultado.aprobo_id"
                :key="resultado.aprobo_id"
              >
                {{ resultado.nombre }}
              </option>
            </select>
            <div
            class="form_cargar_examen_mensaje_error"
              v-if="errores.aprobo_id !== null"
            >
              {{ errores.aprobo_id[0] }}
            </div>
          </div>
          <div class="form_section_editar_socio ancho_form">
            <label for="toma_clase">Evaluador Oficial #1</label>
            <div class="contenedor_select_buscador">
              <v-select
                class="select_buscador minimal"
                v-model.number="examen.evaluador_oficial_1"
                label="item_data"
                :reduce="profesores => profesores.persona_id"
                :options="profesores"
              >
                <span slot="no-options" @click="$refs.select.open = false" class="select_buscador_warning">
                  <p>El profe ingresado no figura en nuestros registros.</p>
                </span>
              </v-select>
            </div>
          </div>
          <div class="form_section_editar_socio ancho_form">
            <label for="toma_clase">Evaluador Oficial #2</label>
            <div class="contenedor_select_buscador">
              <v-select
                class="select_buscador minimal"
                v-model.number="examen.evaluador_oficial_2"
                label="item_data"
                :reduce="profesores => profesores.persona_id"
                :options="profesores"
              >
                <span slot="no-options" @click="$refs.select.open = false" class="select_buscador_warning">
                  <p>El profe ingresado no figura en nuestros registros.</p>
                </span>
              </v-select>
            </div>
          </div>
          <div class="form_section_editar_socio ancho_form">
            <label for="toma_clase">Evaluador Oficial #3</label>
            <div class="contenedor_select_buscador">
              <v-select
                class="select_buscador minimal"
                v-model.number="examen.evaluador_oficial_3"
                label="item_data"
                :reduce="profesores => profesores.persona_id"
                :options="profesores"
              >
                <span slot="no-options" @click="$refs.select.open = false" class="select_buscador_warning">
                  <p>El profe ingresado no figura en nuestros registros.</p>
                </span>
              </v-select>
            </div>
          </div>
          <div class="form_section_editar_socio ancho_form">
            <label for="toma_clase">Evaluador en etrenamiento</label>
            <div class="contenedor_select_buscador">
              <v-select
                class="select_buscador minimal"
                v-model.number="examen.evaluador_entrenamiento"
                label="item_data"
                :reduce="profesores => profesores.persona_id"
                :options="profesores"
              >
                <span slot="no-options" @click="$refs.select.open = false" class="select_buscador_warning">
                  <p>El profe ingresado no figura en nuestros registros.</p>
                </span>
              </v-select>
            </div>
          </div>
          <div class="form_section_editar_socio ancho_form">
            <label for="toma_clase">Evaluador Moderador</label>
            <div class="contenedor_select_buscador">
              <v-select
                class="select_buscador minimal"
                v-model.number="examen.evaluador_moderador"
                label="item_data"
                :reduce="profesores => profesores.persona_id"
                :options="profesores"
              >
                <span slot="no-options" @click="$refs.select.open = false" class="select_buscador_warning">
                  <p>El profe ingresado no figura en nuestros registros.</p>
                </span>
              </v-select>
            </div>
          </div>
          <div class="form_section_editar_socio ancho_form">
            <label for="comentario">Descripción</label>
            <textarea
              name="comentario"
              id="comentario"
              v-model.number="examen.comentario"
            ></textarea>
          </div>
          <div class="form_section_editar_socio ancho_form contenedor_subir_boton">
            <label for="imagen" class="boton_subir_file">Subir planilla de puntaje</label>
            <input
              type="file"
              accept=".png,.jpg,.jpeg,.PNG,.JPG,.JPEG"
              id="imagen"
              ref="imagen"
              @change="encodeImage"
            >
            <div v-if="mostrarBorrarPlanilla" class="contenedor_nombre_file">
              <span>{{ nombrePlanillaPuntaje }}</span>
              <span @click="borrarPlanilla" class="boton_borrar_file">X</span>
            </div>
          </div>
          <div class="form_section_editar_socio ancho_form contenedor_subir_boton">
            <label for="imagen2" class="boton_subir_file">Subir carta de devolución</label>
            <input
              type="file"
              accept=".png,.jpg,.jpeg,.PNG,.JPG,.JPEG"
              id="imagen2"
              ref="imagen2"
              @change="encodeImage2"
            >
            <div v-if="mostrarBorrarCarta" class="contenedor_nombre_file">
              <span>{{ nombreCartaDevolucion }}</span>
              <span @click="borrarCarta" class="boton_borrar_file">X</span>
            </div>
          </div>
          <button type="submit" class="boton_guardar">Cargar</button>
        </form>
      </div>
    </section>
  </div>
</template>
<script src="https://unpkg.com/vue@2"></script>
<script src="https://unpkg.com/vue-select@latest"></script>
<script>
import 'vue-select/dist/vue-select.css';
import personasService from '../services/personas'
// import asociadoService from '../services/asociado'
import examenService from '../services/examen'
import { PATH_IMG } from '../constants'
export default {
  name: 'CargarResultadoExamen',
  components: {
  },
  data: function () {
    return {
      profesores: [],
      mostrarBorrarPlanilla: false,
      mostrarBorrarCarta: false,
      nombrePlanillaPuntaje: null,
      nombreCartaDevolucion: null,
      participante: [],
      perfiles: [],
      certificaciones: [],
      years: [],
      formasDePago: [],
      personas: [],
      monedas: [],
      resultados: [],
      cargando: false,
      persona_id: null,
      // show: true,
      // seleccionado: 5,
      examen: {
        examenes_inscripcion_id: this.$route.params.id,
        persona_id: this.persona_id,
        fecha_examen: null,
        aprobo_id: null,
        certificacion_id: null,
        planilla_puntaje: null,
        carta_devolucion: null,
        evaluador_oficial_1: null,
        evaluador_oficial_2: null,
        evaluador_oficial_3: null,
        evaluador_entrenamiento: null,
        evaluador_moderador: null,
        comentario: null
      },
      errores: {
        fecha_examen: null,
        certificacion_id: null,
        aprobo_id: null
      }
    }
  },
  methods: {
    borrarPlanilla () {
      this.examen.planilla_puntaje = null
      this.mostrarBorrarPlanilla = false
      console.log('wwwweeee')
    },
    borrarCarta () {
      this.examen.carta_devolucion = null
      this.mostrarBorrarCarta = false
      console.log('ww666')
    },
    encodeImage () {
      const extensiones = this.$refs.imagen.value.substring(this.$refs.imagen.value.lastIndexOf('.'), this.$refs.imagen.value.lenght)
      if (this.$refs.imagen.getAttribute('accept').split(',').indexOf(extensiones) < 0) {
        console.log('Formato incorrecto')
      } else if (this.$refs.imagen.files[0].size > 1200000) {
        console.log('Pesadaaaaao')
      } else {
        console.log('rrrrrrrrr')
        // const file = e.target.files[0]
        const file = this.$refs.imagen.files[0]
        this.nombrePlanillaPuntaje = file.name
        console.log(file.name)
        // this.examen.planilla_puntaje = URL.createObjectURL(file)
        const reader = new FileReader()
        reader.addEventListener('load', () => {
          this.examen.planilla_puntaje = reader.result
          console.log('FILE:', reader.result)
        })
        reader.readAsDataURL(file)
        this.mostrarBorrarPlanilla = true
      }
    },
    encodeImage2 () {
      const extensiones = this.$refs.imagen2.value.substring(this.$refs.imagen2.value.lastIndexOf('.'), this.$refs.imagen2.value.lenght)
      if (this.$refs.imagen2.getAttribute('accept').split(',').indexOf(extensiones) < 0) {
        console.log('Formato incorrecto')
      } else if (this.$refs.imagen2.files[0].size > 1200000) {
        console.log('Pesadaaaaao')
      } else {
        console.log('rrrrrrrrr')
        // const file = e.target.files[0]
        const file = this.$refs.imagen2.files[0]
        this.nombreCartaDevolucion = file.name
        // this.examen.planilla_puntaje = URL.createObjectURL(file)
        const reader = new FileReader()
        reader.addEventListener('load', () => {
          this.examen.carta_devolucion = reader.result
          console.log('FILE:', reader.result)
        })
        reader.readAsDataURL(file)
        this.mostrarBorrarCarta = true
      }
    },
    cargarExamen (examen) {
      console.log('qqqq')
      console.log(examen)
      if (this.cargando) {
        return null
      }
      // Reafirmo que el perfil visitante tenga certificacion 1
      // if (this.socio.perfil_id === 2) {
      //   this.socio.certificacion_id = 1
      // }
      this.errores = {
        fecha_examen: null,
        certificacion_id: null,
        planilla_puntaje: null,
        aprobo_id: null
      }
      this.cargando = true
      examenService
        .cargarExamen(examen)
        .then(respuesta => {
          this.cargando = false
          if (respuesta.success) {
            console.log('SIIIIII')
            this.examen = {
              fecha_examen: null,
              certificacion_id: null,
              planilla_puntaje: null,
              carta_devolucion: null
            }
            this.errores = {
              fecha_examen: null,
              certificacion_id: null,
              aprobo_id: null
            }
            this.$router.push('/datos-inscripcion-examen/' + `${this.$route.params.id}`)
          } else {
            this.errores = {
              fecha_examen: null,
              certificacion_id: null,
              aprobo_id: null,
              ...respuesta.errors
            }
          }
        })
    }
  },
  computed: {
    imagenRuta: function () {
      return `${PATH_IMG}/${this.participante.persona.imagen_perfil}`
    }
  },
  mounted: function () {
    console.log('aaaassssssaaaa')
    personasService
      .traerPerfilesTodos()
      .then(respuesta => {
        // this.cargando = false
        this.perfiles = respuesta
      })
    personasService
      .traerCertificacionesTodas()
      .then(respuesta => {
        // this.cargando = false
        this.certificaciones = respuesta
      })
    examenService
      .traerResultadosTodos()
      .then(respuesta => {
        // this.cargando = false
        this.resultados = respuesta
        console.log('Resultados: ', respuesta)
      })
    examenService
      .traerDatosAnotadosExamen(this.$route.params.id)
      .then(respuesta => {
        // this.cargando = false
        console.log('Datos: ', respuesta)
        console.log('persona_id: ', respuesta.persona_id)
        this.participante = respuesta
        this.examen.persona_id = respuesta.persona_id
      })
    examenService
      .traerProfesoresExaminadores()
      .then(respuesta => {
        // this.cargando = false
        this.profesores = respuesta
        console.log('Profesores:', respuesta)
        this.profesores.map(function (x) {
          return x.item_data = x.nombre + ' ' + x.apellido
        })
      })
  }
}
</script>
